const uiActionTypes = {
	setModal: 'SET_MODAL',
	closeModal: 'CLOSE_MODAL',
	showIconCloseModal: 'SHOW_ICON_CLOSE_MODAL',
	setPopupTop: 'SET_POPUP_TOP',
	closePopupTop: 'CLOSE_POPUP_TOP',
	showLoading: 'SHOW_LOADING',
	setInstallPrompt: 'SET_INSTALL_PROMPT',
	setControlBack: 'SET_CONTROL_BACK',
	resetControlBack: 'RESET_CONTROL_BACK',
	toggleSliderMenu: 'TOGGLE-SLIDE-MENU',
	toggleMenu: 'TOGGLE-MENU',
	openOverlay: 'OPEN-OVERLAY',
	closeOverlay: 'CLOSE-OVERLAY',
	handledNavBar: 'HANDLED_NAV_BAR'
}

export default uiActionTypes
